import { Box, CircularProgress } from '@mui/material';
import React from 'react';

const SplashScreen = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        width: '100vw',
        height: '100vh',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 2,
      }}
    >
      ... درحال بارگیری
      <CircularProgress style={{ width: '2em', height: '2em' }} />
    </Box>
  );
};

export default SplashScreen;
